import React from 'react';
import './blog-post.css';

import tech1 from './pictures/tech1.jpeg';
import tech2 from './pictures/tech2.jpg';
import tech3 from './pictures/tech3.jpg';
import tech4 from './pictures/tech4.jpg';
import tech5 from './pictures/tech5.jpg';
import tech6 from './pictures/tech6.jpg';


//import reportWebVitals from './reportWebVitals';

const Tech = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Getting Stared with Tech Entrepreneurship Recap</h2>
                    <p class="site-post-meta">February 15th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>                   
                    WiC and WE Lead from the Buerk Center collaborated to host “Getting Started with Entrepreneurship.”
                    <br></br>
                    <br></br>
                    This event introduced students to what tech entrepreneurship looks like including a panel with 
                    3 women tech entrepreneurs: Joan Palmiter Bajorek, Nikita Gupta, and Nabanita De; 
                    an Idea-Thon activity and Thai food for dinner!
                    <br></br>
                    <br></br>
                    It was super inspiring to hear the entrepreneurial journeys of our speakers, 
                    what they are currently working on, and their advice for women interested in tech 
                    entrepreneurship. Each of our speakers provided amazing insights on current trends 
                    in tech and how students can get started with building their ideas! 
                    <br></br>
                     
                    </p>
                     <img src={tech1} alt="Group picture with speakers"/>
                     <img src={tech2} alt="Speaker panelists"/>
                     <img src={tech3} alt="Q&A panel"/>
                     <img src={tech4} alt="Q&A panel"/>
                     <img src={tech5} alt="Q&A panel"/>
                     <img src={tech6} alt="Ideathon"/>

                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Tech;

